import React from 'react';
import styles from '../maruciapiercer/maruciapiercer.module.scss';
import perfil from '../maruciapiercer/src/perfil.png';
import { Link } from 'react-router-dom';

const cardImages = [
    {
        id: 1,
        image: require("./src/cards/1.png"),
        link: "https://wa.me/5516991127373?text=Olá, vim pelo link na bio e gostaria de agendar um horário (Piercing)...",
        linkInterno: false
    },
    {
        id: 2,
        image: require("./src/cards/2.png"),
        link: "https://wa.me/5516991127373?text=Olá, vim pelo link na bio e gostaria de agendar um horário (Depilação e Sobrancelha)...",
        linkInterno: false
    },
    {
        id: 3,
        image: require("./src/cards/3.png"),
        link: "https://maps.app.goo.gl/Q7x2Qq3FkowMMJzd7",
        linkInterno: false
    },
    {
        id: 4,
        image: require("./src/cards/4.png"),
        link: "/maruciapiercer/sobremim",
        linkInterno: true
    },
    // {
    //     id: 5,
    //     image: require("./src/cards/5.png"),
    //     link: "/maruciapiercer/trabalhos",
    //     linkInterno: true
    // },
    {
        id: 6,
        image: require("./src/cards/6.png"),
        link: "https://www.instagram.com/marucia.piercer?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        linkInterno: false
    },
];

const Maruciapiercer: React.FC = () => {
    return (
        <div className={styles.maruciapiercer}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card, index) => (
                        card.linkInterno ?
                            <Link to={card.link} key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </Link>
                            :
                            <a href={card.link} key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Maruciapiercer;
